/**
 * Firestore collection names used throughout the application.
 * Centralized to ensure consistency and prevent typos.
 */

export const FIRESTORE_COLLECTIONS = {
  USERS: "users",
  THREADS: "threads",
  MESSAGES: "messages",
  FAQ: "faq",
  ORGANISATIONS: "organisations",
  BOARDS: "boards",
  IDEAS: "ideas",
  VOTES: "votes",
  CHECKS: "checks",
} as const;
